import { createAction } from '@reduxjs/toolkit';

const reauthRequired = createAction('auth/reauthRequired');

export { reauthRequired };
